// src/components/Fields/HeaderPreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import TitleIcon from '@mui/icons-material/Title';
import DraggablePreviewWrapper from './DraggablePreviewWrapper';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext'; // Adjust path as necessary

const HeaderPreview = ({ id, index }) => {
//  console.log('[HeaderPreview] Rendering with props:', { id, index });

    const { showDropZones, setShowDropZones } = useFormLayout();  // Use context to manage showDropZones
//  console.log('[HeaderPreview] Current drop zone state:', { showDropZones });

    // Render component with setShowDropZones passed to DraggablePreviewWrapper
    return (
        <DraggablePreviewWrapper
            id={id}
            type="header"
            index={index}
            isNew={true}
            showDropZones={showDropZones} // Pass down showDropZones state
            setShowDropZones={setShowDropZones} // Pass down setShowDropZones function
        >
            <Box display="flex" alignItems="center">
                <TitleIcon sx={{ fontSize: '0.95rem', marginRight: '8px', color: '#455A64' }} />
                <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
                    Header
                </Typography>
            </Box>
        </DraggablePreviewWrapper>
    );
};

export default HeaderPreview;
